'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = Box;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SpruceClassName = require('stampy/lib/util/SpruceClassName');

var _SpruceClassName2 = _interopRequireDefault(_SpruceClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @module Components
 */

/**
 * @component
 *
 * Box is an empty component that has shortcuts to style margin and padding
 *
 * @example
 * return <Box marginBottom="1rem" padding="1rem"><Input/></Box>
 */

function remify(rems) {
    return rems && typeof rems === 'string' ? rems.trim().split(' ').join('rem ') + 'rem' : undefined;
}

function Box(props) {
    var children = props.children;
    var className = props.className;
    var _props$element = props.element,
        Element = _props$element === undefined ? 'div' : _props$element;
    var marginBottom = props.marginBottom;
    var marginLeft = props.marginLeft;
    var marginRight = props.marginRight;
    var marginTop = props.marginTop;
    var margin = props.margin;
    var modifier = props.modifier;
    var paddingBottom = props.paddingBottom;
    var paddingLeft = props.paddingLeft;
    var paddingRight = props.paddingRight;
    var paddingTop = props.paddingTop;
    var padding = props.padding;
    var parent = props.parent;
    var _props$spruceName = props.spruceName,
        spruceName = _props$spruceName === undefined ? 'Box' : _props$spruceName;
    var style = props.style;
    var _props$boxProps = props.boxProps,
        boxProps = _props$boxProps === undefined ? {} : _props$boxProps;


    return _react2.default.createElement(Element, (0, _extends3.default)({
        className: (0, _SpruceClassName2.default)({ name: spruceName, modifier: modifier, className: className, parent: parent }),
        children: children
    }, boxProps, {
        style: (0, _extends3.default)({}, style, {
            margin: remify(margin),
            marginBottom: remify(marginBottom),
            marginLeft: remify(marginLeft),
            marginRight: remify(marginRight),
            marginTop: remify(marginTop),
            padding: remify(padding),
            paddingBottom: remify(paddingBottom),
            paddingLeft: remify(paddingLeft),
            paddingRight: remify(paddingRight),
            paddingTop: remify(paddingTop)
        })
    }));
}


//////////////////
// WEBPACK FOOTER
// ./~/react-goose/lib/position/Box.js
// module id = 137
// module chunks = 35783957827783 114276838955818 162898551421021